import React from 'react';
import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import { INFO_CARD_STYLES } from './InfoCardStyles';

const useStyles = makeStyles((theme) => INFO_CARD_STYLES(theme));

const HeaderPaper = ({content}) => {
  return (
    <div >
      {content}
    </div>
  );
};

const ContentPaper = ({content}) => {
  return (
    <div>
      {content}
    </div>
  );
};

interface InfoCardProps {
  title: string;
  value: string | number | null | undefined;
  xs?: number;
  sm?: number;
  md?: number;
}

const InfoCard: React.FC<InfoCardProps> = ({ title, value }) => {
  const classes = useStyles();
  return (
    <div className={classes.card}>
      <Grid className={classes.infocard}>
        <div className={classes.cardHeader}>
          <HeaderPaper content={title}></HeaderPaper>
        </div>
        <div className={classes.cardContent}>
        <ContentPaper content={value ?? 'N/A'}></ContentPaper>
        </div>
      </Grid>
    </div>
    
  );
};

export default InfoCard;

